import { datecreatedProp, defaultData, sectionKeys } from "./defaultData";
import { getMedIdType } from "./getMedIdType";
import { unifyDate } from "../../../../../../utils";

const inputsValueParser = (input: any, incomingValue: string | undefined) => {
  let parsedValue = incomingValue === "[]" ? "" : (incomingValue ?? "");
  if (input.name === datecreatedProp && incomingValue) {
    parsedValue = unifyDate(incomingValue);
  }
  return { ...input, value: parsedValue };
};

const parseOthersData = (dataKey: string, data: any, index: number) => {
  const order = defaultData.others[index].rows[0].inputs.map(i => i.name);
  const inputParser = (row: any) => ({
    inputs: order
      .map(name => {
        const value = name in row ? row[name] : undefined;
        const matchingInput = defaultData.others[index].rows[0].inputs.find(
          input => input.name === name,
        );
        if (!matchingInput) return undefined;

        if (name === "attachment") {
          return {
            ...matchingInput,
            value: row.attachment || [],
          };
        }

        return inputsValueParser(matchingInput, value);
      })
      .filter(Boolean),
    [getMedIdType(dataKey)]: row[getMedIdType(dataKey)] ?? null,
  });

  return {
    ...defaultData.others[index],
    headers: defaultData.others[index].headers,
    rows:
      data[dataKey]?.length > 0
        ? data[dataKey].map(inputParser)
        : dataKey === "medMedicalCard" && data[dataKey]
          ? [inputParser(data[dataKey])]
          : defaultData.others[index].rows.map(row => ({
              ...row,
              [getMedIdType(dataKey)]: null,
            })),
  };
};

export const mapMedData = (data: any) => {
  if (!data?.data) return defaultData;
  const { patient, medLeaveHistory, hasMedCardStatement, patientInfo } =
    data.data;
  const parsedData = {
    ...defaultData,
    hasMedCardStatement,
    patientInformation: {
      patientId: patientInfo?.patientid || data?.data?.patientid || null,
      URN: patient.ref,
      name: `${patient.firstname} ${patient.surname}`,
      attachments: patientInfo?.attachments || [],
      inputs: defaultData.patientInformation.inputs.map(i =>
        inputsValueParser(
          i,
          i.name === "status"
            ? patient.active
              ? "Active"
              : "Inactive"
            : patientInfo?.data?.[i.name],
        ),
      ),
    },
    leaveHistory: {
      ...defaultData.leaveHistory,
      medLeaveHistory,
      inputs: defaultData.leaveHistory.inputs.map(i =>
        inputsValueParser(i, patient[i.name]),
      ),
    },
    others: sectionKeys.map((dataKey, index) =>
      parseOthersData(dataKey, data.data, index),
    ),
  };
  return parsedData;
};
